import { ROUTES } from 'app-constants'
import { Link } from 'react-router-dom'
import { useRemindPasswordLater } from 'hooks'
import './style.scss'

export function RemindLaterLink({ label }) {
  const { setRemindPasswordLater } = useRemindPasswordLater()

  function handleRemindLater() {
    setRemindPasswordLater(true)
  }

  return (
    <div className='remind-later-link'>
      <Link to={ROUTES.HOME.PATH} onClick={handleRemindLater}>
        {label}
      </Link>
    </div>
  )
}
